export default "__VITE_ASSET__WEX8eZTg__"